// LoadingSpinner.js
import React from 'react';
import { Spinner, Flex } from '@chakra-ui/react';

const LoadingSpinner = () => (
	<Flex justify='center' align='center' height='100vh' width='100vw'>
		<Spinner size='xl' color='brand.500' thickness='4px' />
	</Flex>
);

export default LoadingSpinner;
